import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  const t = props.t;

  return (
    <nav

      className={classes}
    >
      <ul className="list-reset">
        <li>
          <Link to="#privacy">{t('Privacy')}</Link>
        </li>
        <li>
          <Link to="#legal-notice">{t('Legal Notice')}</Link>
        </li>
        <li>
          <Link to="#cgv">{t('CGV')}</Link>
        </li>
        <li style={{marginLeft:'25px'}}>
          <Link to="#support"><b>{t('Support')}</b></Link>
        </li>
        <li>
          <Link to="/signup">{t('Login')}</Link>
        </li>
      </ul>
    </nav>
  );
}

export default withTranslation()(FooterNav);
